import React, { useContext, useMemo, useState } from "react";
import "./index.scss";
import Formula3DPreview from "../../../FormulaGenerator/Formula3DPreview";
import IconFace6 from "./images/face6.png";
import IconFace8 from "./images/face8.png";
import IconFace10 from "./images/face10.png";
import IconFace20 from "./images/face20.png";
import SelectionTypeList from "../../SelectionTypeList";
import { StepContext } from "../../StepContext";
import { useTranslation } from "../../../i18n";

const SmileSelect = () => {
  const {
    _t
  } = useTranslation();
  const {
    setPatientFace,
    dentalData,
    patientGender,
    patientFace
  } = useContext(StepContext);
  const availableTypes = useMemo(() => {
    return [{
      key: "face6",
      img: IconFace6,
      name: _t("6 зубов видно при улыбке")
    }, {
      key: "face8",
      img: IconFace8,
      name: _t("8 зубов видно при улыбке")
    }, {
      key: "face10",
      img: IconFace10,
      name: _t("10 зубов видно при улыбке")
    }, {
      key: "face20",
      img: IconFace20,
      name: _t("20 зубов видно при улыбке")
    }];
  }, [_t]);
  const [isFormulaLoaded, setIsFormulaLoaded] = useState(false);

  function formulaLoadedCallback() {
    setIsFormulaLoaded(true);
  }

  function setData(key) {
    if (!isFormulaLoaded) {
      return;
    }

    setPatientFace(key);
  }

  return /*#__PURE__*/React.createElement("div", {
    className: "smileSelect"
  }, /*#__PURE__*/React.createElement("div", {
    className: "smileSelect-types"
  }, /*#__PURE__*/React.createElement("p", null, _t("Выберите ниже")), /*#__PURE__*/React.createElement(SelectionTypeList, {
    types: availableTypes,
    selected: patientFace,
    setData: setData,
    columns: 2,
    disable: !isFormulaLoaded
  })), /*#__PURE__*/React.createElement("div", {
    className: "smileSelect-container"
  }, /*#__PURE__*/React.createElement(Formula3DPreview, {
    stlPack: dentalData,
    availableSwitchers: ["top", "bottom", "base", "fixedProstheses"],
    hideNotUsedSides: false,
    hideHeadMaskSwitcher: false,
    headMaskEnabled: true,
    headMaskType: `${patientGender}_${patientFace}`,
    onLoaded: formulaLoadedCallback
  })));
};

export default SmileSelect;